import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { ProjectHours } from 'api/project';
import { BodyShort02, Label01 } from 'ozone/atoms';
import { Percentage } from './components';

export interface Props {
  projectHours: ProjectHours;
}

type WidgetProps = {
  title: ReactNode;
  value: ReactNode;
  percentage?: ReactNode;
};

const WidgetContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Caption = styled(Label01)`
  color: var(--gray-50);
`;

export const Widget: FC<WidgetProps> = ({ title, value, percentage }) => (
  <WidgetContainer>
    <Caption>{title}</Caption>
    <BodyShort02>
      {value}
      {percentage == null ? null : <Percentage>{percentage}</Percentage>}
    </BodyShort02>
  </WidgetContainer>
);
